import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMore = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 8C13.1048 8 14 7.10453 14 6C14 4.89547 13.1048 4 12 4C10.8952 4 10 4.89547 10 6C10 7.10453 10.8952 8 12 8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10 18C10 19.1045 10.8952 20 12 20C13.1048 20 14 19.1045 14 18C14 16.8955 13.1048 16 12 16C10.8952 16 10 16.8955 10 18Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 10C10.8952 10 10 10.8955 10 12C10 13.1045 10.8952 14 12 14C13.1048 14 14 13.1045 14 12C14 10.8955 13.1048 10 12 10Z",
			fill: "currentColor"
		})
	]
});
export default SvgMore;
